import React from 'react';
import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { Field } from 'formik';
import CustomRadio from '../../common/ui/CustomRadio';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
const ItemDbConfig = ({ sameAsAbove, values, setFieldValue, handleCheckboxChange }) => {
  return (
    <AccordionItem uuid="collection-item-db-config">
      <AccordionItemHeading>
        <AccordionItemButton>
          <i className={`wb`}></i>
          <strong>Collection Item Database Configuration (Mongo DB)</strong>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <div className="form-check" style={{ paddingLeft: 20 }}>
          <CustomRadio label="Same as above" isRadio={false}>
            <input
              name="sameAsAbove"
              type="checkbox"
              className="form-check-input"
              checked={sameAsAbove}
              onChange={(e) => handleCheckboxChange(e, values, setFieldValue)}
            />
          </CustomRadio>
        </div>
        <div className="row">
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="itemDB.host"
                className="form-control form-control-sm"
                placeholder="Database Host/IP"
                title="Enter Database Host/IP"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="itemDB.port"
                className="form-control form-control-sm"
                placeholder="Database Port"
                title="Enter Database Port"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                name="itemDB.username"
                className="form-control form-control-sm"
                placeholder="Database Username"
                title="Enter Database Username"
              />
            </CustomInputWithIcon>
          </div>
          <div className="col-md-6">
            <CustomInputWithIcon icon="text">
              <Field
                type="password"
                name="itemDB.password"
                className="form-control form-control-sm"
                placeholder="Database Password"
                title="Enter Database Password"
              />
            </CustomInputWithIcon>
          </div>
        </div>
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default ItemDbConfig;
